var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "common_screen" }, [
    _vm.type == 1
      ? _c("div", { staticClass: "screen_con" }, [
          _c(
            "div",
            { staticClass: "first_row item" },
            [
              _c("div", { staticClass: "screen_type" }, [
                _c("span", { staticClass: "screen_title" }, [
                  _vm._v("待办状态："),
                ]),
                _c(
                  "div",
                  _vm._l(_vm.dealStatusList, function (item, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "screen_btn",
                        class:
                          item.value == _vm.dealForm.historyid ? "check" : null,
                        on: {
                          click: function ($event) {
                            return _vm.dealStatusHandle(item.value)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isOpen,
                      expression: "!isOpen",
                    },
                  ],
                  attrs: { type: "text" },
                  on: { click: _vm.openClick },
                },
                [_vm._v("展开")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen",
                    },
                  ],
                  attrs: { type: "text" },
                  on: { click: _vm.openClick },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen",
                },
              ],
              staticClass: "is_open",
            },
            [
              _c("div", { staticClass: "item" }, [
                _c(
                  "div",
                  [
                    _c("span", { staticClass: "screen_title" }, [
                      _vm._v("处理部门："),
                    ]),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "400px" },
                        attrs: {
                          placeholder: "请选择",
                          mode: "multiple",
                          "option-label-prop": "label",
                        },
                        on: { change: _vm.dealAssigneeidHandle },
                        model: {
                          value: _vm.dealForm.assigneeids,
                          callback: function ($$v) {
                            _vm.$set(_vm.dealForm, "assigneeids", $$v)
                          },
                          expression: "dealForm.assigneeids",
                        },
                      },
                      _vm._l(_vm.departmentlist, function (item) {
                        return _c(
                          "a-select-option",
                          {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          },
                          [_vm._v(_vm._s(item.name) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "item" }, [
                _c(
                  "div",
                  { staticClass: "two_row" },
                  [
                    _c("span", { staticClass: "screen_title" }, [
                      _vm._v("提交时间："),
                    ]),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      on: { change: _vm.dealCreatedDateHandle },
                      model: {
                        value: _vm.dealCreateDate,
                        callback: function ($$v) {
                          _vm.dealCreateDate = $$v
                        },
                        expression: "dealCreateDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "two_row" },
                  [
                    _c("span", { staticClass: "screen_title" }, [
                      _vm._v("处理时间："),
                    ]),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      on: { change: _vm.dealProcessDateHandle },
                      model: {
                        value: _vm.dealProcessDate,
                        callback: function ($$v) {
                          _vm.dealProcessDate = $$v
                        },
                        expression: "dealProcessDate",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm.type == 2
      ? _c("div", { staticClass: "screen_con" }, [
          _vm.navClick == "GC" || _vm.navClick == "CG"
            ? _c("div", { staticClass: "first_row item" }, [
                _c("div", { staticClass: "screen_type" }, [
                  _c("span", { staticClass: "screen_title" }, [
                    _vm._v("项目类型："),
                  ]),
                  _c(
                    "div",
                    _vm._l(_vm.projectTypeList, function (item, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "screen_btn",
                          class:
                            item.value == _vm.openForm.openType
                              ? "check"
                              : null,
                          on: {
                            click: function ($event) {
                              return _vm.openTypeHandle(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.isOpen || _vm.navClick == "GT" || _vm.navClick == "CQ"
            ? _c("div", { staticClass: "is_open" }, [
                _vm.navClick == "GT" || _vm.navClick == "CQ"
                  ? _c("div", { staticClass: "item" }, [
                      _c(
                        "div",
                        { staticClass: "two_row" },
                        [
                          _c("span", { staticClass: "screen_title" }, [
                            _vm._v("竞价时间："),
                          ]),
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.type == 3
      ? _c("div", { staticClass: "screen_con" }, [
          _c("div", { staticClass: "first_row item" }, [
            _c("div", { staticClass: "screen_type" }, [
              _c("span", { staticClass: "screen_title" }, [
                _vm._v("项目状态："),
              ]),
              _vm.navClick == "GC" || _vm.navClick == "CG"
                ? _c(
                    "div",
                    _vm._l(_vm.projectStatusList, function (item, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "screen_btn",
                          class:
                            item.value == _vm.projectForm.projectStatus
                              ? "check"
                              : null,
                          on: {
                            click: function ($event) {
                              return _vm.projectStatusHandle(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.navClick == "CQ" || _vm.navClick == "GT"
                ? _c(
                    "div",
                    _vm._l(_vm.projectStatusList1, function (item, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "screen_btn",
                          class:
                            item.value == _vm.projectForm.projectStatus
                              ? "check"
                              : null,
                          on: {
                            click: function ($event) {
                              return _vm.projectStatusHandle(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: true,
                  expression: "true",
                },
              ],
              staticClass: "is_open",
            },
            [
              _vm.navClick == "GC" || _vm.navClick == "CG"
                ? _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "screen_type" }, [
                      _c("span", { staticClass: "screen_title" }, [
                        _vm._v("项目类型："),
                      ]),
                      _c(
                        "div",
                        _vm._l(_vm.projectTypeList, function (item, i) {
                          return _c(
                            "span",
                            {
                              key: i,
                              staticClass: "screen_btn",
                              class:
                                item.value == _vm.projectForm.projectType
                                  ? "check"
                                  : null,
                              on: {
                                click: function ($event) {
                                  return _vm.projectTypeHandle(item.value)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      ),
                    ]),
                  ])
                : _vm._e(),
              true
                ? _c("div", { staticClass: "item items" }, [
                    _c(
                      "div",
                      { staticClass: "three_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("开标时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { change: _vm.projecBidOpenTimeHandle },
                          model: {
                            value: _vm.projecBidOpenTime,
                            callback: function ($$v) {
                              _vm.projecBidOpenTime = $$v
                            },
                            expression: "projecBidOpenTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "three_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("中标结果公告时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: {
                            change: _vm.projecBuyprojectresultnoticeTimeHandle,
                          },
                          model: {
                            value: _vm.projecBuyprojectresultnoticeTime,
                            callback: function ($$v) {
                              _vm.projecBuyprojectresultnoticeTime = $$v
                            },
                            expression: "projecBuyprojectresultnoticeTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "four_row",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        width: "100%",
                      },
                    },
                    [
                      _vm._m(0),
                      _c("select-depart-tree", {
                        ref: "selectDepartTreeRef",
                        attrs: {
                          type: "2",
                          modelValue: _vm.projectForm.superviseDeptCodeList,
                          isMultiple: true,
                          widthValue: 765,
                        },
                        on: {
                          "update:modelValue": function ($event) {
                            return _vm.$set(
                              _vm.projectForm,
                              "superviseDeptCodeList",
                              $event
                            )
                          },
                          "update:model-value": function ($event) {
                            return _vm.$set(
                              _vm.projectForm,
                              "superviseDeptCodeList",
                              $event
                            )
                          },
                          handleDeptType: (val) => _vm.changeDept(val, "5"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "searchBtn" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.resetData },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.navClick == "CQ" || _vm.navClick == "GT"
                ? _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "two_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("限时竞价时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            "end-placeholder": "结束日期",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { change: _vm.projecBidOpenTimeHandle },
                          model: {
                            value: _vm.projecEntryTime,
                            callback: function ($$v) {
                              _vm.projecEntryTime = $$v
                            },
                            expression: "projecEntryTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "two_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("中标结果公告时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: {
                            change: _vm.projecBuyprojectresultnoticeTimeHandle,
                          },
                          model: {
                            value: _vm.projecBuyprojectresultnoticeTime1,
                            callback: function ($$v) {
                              _vm.projecBuyprojectresultnoticeTime1 = $$v
                            },
                            expression: "projecBuyprojectresultnoticeTime1",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
    _vm.type == 4
      ? _c("div", { staticClass: "screen_con" }, [
          _c("div", { staticClass: "first_row item" }, [
            _c("div", { staticClass: "screen_type" }, [
              _c("span", { staticClass: "screen_title" }, [
                _vm._v("项目状态："),
              ]),
              _vm.navClick == "GC" || _vm.navClick == "CG"
                ? _c(
                    "div",
                    _vm._l(_vm.projectStatusList, function (item, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "screen_btn",
                          class:
                            item.value == _vm.projectForm.projectStatus
                              ? "check"
                              : null,
                          on: {
                            click: function ($event) {
                              return _vm.projectStatusHandle(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.navClick == "CQ" || _vm.navClick == "GT"
                ? _c(
                    "div",
                    _vm._l(_vm.projectStatusList1, function (item, i) {
                      return _c(
                        "span",
                        {
                          key: i,
                          staticClass: "screen_btn",
                          class:
                            item.value == _vm.projectForm.projectStatus
                              ? "check"
                              : null,
                          on: {
                            click: function ($event) {
                              return _vm.projectStatusHandle(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: true,
                  expression: "true",
                },
              ],
              staticClass: "is_open",
            },
            [
              _vm.navClick == "GC" || _vm.navClick == "CG"
                ? _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "screen_type" }, [
                      _c("span", { staticClass: "screen_title" }, [
                        _vm._v("项目类型："),
                      ]),
                      _c(
                        "div",
                        _vm._l(_vm.projectTypeList, function (item, i) {
                          return _c(
                            "span",
                            {
                              key: i,
                              staticClass: "screen_btn",
                              class:
                                item.value == _vm.projectForm.projectType
                                  ? "check"
                                  : null,
                              on: {
                                click: function ($event) {
                                  return _vm.projectTypeHandle(item.value)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        0
                      ),
                    ]),
                  ])
                : _vm._e(),
              true
                ? _c("div", { staticClass: "item" }, [
                    _c(
                      "div",
                      { staticClass: "two_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("项目进场时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            "end-placeholder": "结束日期",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { change: _vm.projecEntryTimeHandle },
                          model: {
                            value: _vm.projecEntryTime,
                            callback: function ($$v) {
                              _vm.projecEntryTime = $$v
                            },
                            expression: "projecEntryTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "two_row" },
                      [
                        _c("span", { staticClass: "screen_title" }, [
                          _vm._v("开标时间："),
                        ]),
                        _c("el-date-picker", {
                          attrs: {
                            "end-placeholder": "结束日期",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { change: _vm.projecBidOpenTimeHandle },
                          model: {
                            value: _vm.projecBidOpenTime,
                            callback: function ($$v) {
                              _vm.projecBidOpenTime = $$v
                            },
                            expression: "projecBidOpenTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "item" }, [
                _c(
                  "div",
                  { staticClass: "two_row" },
                  [
                    _c("span", { staticClass: "screen_title" }, [
                      _vm._v("中标结果公告发布时间："),
                    ]),
                    _c("el-date-picker", {
                      attrs: {
                        "end-placeholder": "结束日期",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        type: "daterange",
                        "value-format": "yyyy-MM-dd",
                      },
                      on: {
                        change: _vm.projecBuyprojectresultnoticeTimeHandle,
                      },
                      model: {
                        value: _vm.projecBuyprojectresultnoticeTime,
                        callback: function ($$v) {
                          _vm.projecBuyprojectresultnoticeTime = $$v
                        },
                        expression: "projecBuyprojectresultnoticeTime",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "four_row",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        width: "100%",
                      },
                    },
                    [
                      _vm._m(1),
                      _c("select-depart-tree", {
                        ref: "selectDepartTreeRef",
                        attrs: {
                          type: "2",
                          modelValue: _vm.projectForm.superviseDeptCodeList,
                          isMultiple: true,
                          widthValue: 765,
                        },
                        on: {
                          "update:modelValue": function ($event) {
                            return _vm.$set(
                              _vm.projectForm,
                              "superviseDeptCodeList",
                              $event
                            )
                          },
                          "update:model-value": function ($event) {
                            return _vm.$set(
                              _vm.projectForm,
                              "superviseDeptCodeList",
                              $event
                            )
                          },
                          handleDeptType: (val) => _vm.changeDept(val, "5"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "searchBtn" },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.resetFlowEfficiencyData } },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm.type == 5
      ? _c("div", { staticClass: "screen_con" }, [
          _c("div", { staticClass: "first_row item" }, [
            _c("div", { staticClass: "screen_type" }, [
              _c("span", { staticClass: "screen_title" }, [
                _vm._v("项目状态："),
              ]),
              _c(
                "div",
                _vm._l(_vm.projectReleaseStatusList, function (item, i) {
                  return _c(
                    "span",
                    {
                      key: i,
                      staticClass: "screen_btn",
                      class:
                        item.value == _vm.projectForm.projectStatus
                          ? "check"
                          : null,
                      on: {
                        click: function ($event) {
                          return _vm.projectStatusHandle(item.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "is_open" }, [
            false
              ? _c("div", { staticClass: "item items" }, [
                  _c(
                    "div",
                    { staticClass: "three_row" },
                    [
                      _c("span", { staticClass: "screen_title" }, [
                        _vm._v("预计招标时间："),
                      ]),
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.projecBidOpenTimeHandle },
                        model: {
                          value: _vm.projecBidOpenTime,
                          callback: function ($$v) {
                            _vm.projecBidOpenTime = $$v
                          },
                          expression: "projecBidOpenTime",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            false
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "four_row",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "100%",
                          "padding-bottom": "8px",
                        },
                      },
                      [
                        _vm._m(2),
                        _c("select-depart-tree", {
                          ref: "selectDepartTreeRef",
                          attrs: {
                            type: "2",
                            modelValue: _vm.projectForm.superviseDeptCodeList,
                            isMultiple: true,
                            widthValue: 765,
                          },
                          on: {
                            "update:modelValue": function ($event) {
                              return _vm.$set(
                                _vm.projectForm,
                                "superviseDeptCodeList",
                                $event
                              )
                            },
                            "update:model-value": function ($event) {
                              return _vm.$set(
                                _vm.projectForm,
                                "superviseDeptCodeList",
                                $event
                              )
                            },
                            handleDeptType: (val) => _vm.changeDept(val, "5"),
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "item items" }, [
              _c("div", { staticClass: "screen_type" }, [
                _c("span", { staticClass: "screen_title" }, [
                  _vm._v("所属地区："),
                ]),
                _c(
                  "div",
                  _vm._l(_vm.userRegionCodeList, function (item, i) {
                    return _c(
                      "span",
                      {
                        key: i,
                        staticClass: "screen_btn",
                        class:
                          item.id == _vm.projectForm.regionCode
                            ? "check"
                            : null,
                        on: {
                          click: function ($event) {
                            return _vm.regionCodeHandle(item.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "searchBtn" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.resetData } },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "screen_title" }, [_vm._v("数据所属部门：")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "span",
        {
          staticClass: "screen_title",
          staticStyle: { "margin-right": "20px" },
        },
        [_vm._v("数据所属部门：")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "screen_title" }, [_vm._v("数据所属部门：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }